import React from 'react';
import PropTypes from 'prop-types';
import { DepthOfFieldSnowfall } from 'react-snowflakes/src';
import Footer from './Footer';
import Door from './Door';
import { AdventCalendarContainer } from './styled/AdventCalendar';
import CalendarFinishedPopupContainer from "./CalendarFinishedPopup";

export default class AdventCalendar extends React.Component {
  mobileBreakpoint = 768;

  constructor(props) {
    super(props);

    const { AdventCount: { calendarData } } = window;

    this.initializeState(calendarData[props.calendarId]);
    this.doorClickHandler = this.doorClickHandler.bind(this);
    this.onWindowResize = this.onWindowResize.bind(this);
    this.calculatePercentDecrease = this.calculatePercentDecrease.bind(this);
    this.setImageRef = this.setImageRef.bind(this);
    this.setContainerRef = this.setContainerRef.bind(this);
    this.setDoorSize = this.setDoorSize.bind(this);
    this.calcuateSize = this.calcuateSize.bind(this);

    this.now = Math.round(Date.now() / 1000);
    this.FinishedDialogShown = true;
  }

  componentDidMount() {
    const { internalPreview } = this.props;
    const { doorSize } = this.state;

    if (internalPreview) {
      this.registerGlobalUpdateMethods();
    }

    this.originalDoorWidth = doorSize;

    window.addEventListener('resize', this.onWindowResize);
    this.onWindowResize();
  }

  componentWillUnmount() {
    const { internalPreview } = this.props;

    if (internalPreview && window.AdventCalendar) {
      const { ID } = this.state;
      delete window.AdventCalendar[ID];
    }

    window.removeEventListener('resize', this.onWindowResize);
    this.image.removeEventListener('load', this.setDoorSize);
  }

  calculatePercentDecrease = (original, modified) => (original - modified) / original;

  setDoorSize = () => {
    const { displayMobile, displayMobileType } = this.state;
    const { internalPreview } = this.props;

    if (this.image && this.container) {
      if ( !displayMobile || displayMobileType === 'all') {
        const {
          data_natural_width,
          data_width,
        } = this.getBackgroundImageDimensions();

        const doorWidth = parseInt(this.originalDoorWidth, 10)
          * (1 - this.calculatePercentDecrease(data_natural_width, data_width));
        this.setState({
          doorSize: doorWidth,
        });
      } else {
        this.setState({
          doorSize: 80,
        });
      }
    }
  };

	calcuateSize = (size) => {
		const { displayMobile, displayMobileType } = this.state;
		const { internalPreview } = this.props;

		if (this.image && this.container) {
			if ( !displayMobile || displayMobileType === 'all') {
				const {
					data_natural_width,
					data_width,
				} = this.getBackgroundImageDimensions();

				return parseInt(size, 10)
					* (1 - this.calculatePercentDecrease(data_natural_width, data_width));
			}
		}

		return 80;
	};

  onWindowResize = () => {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      const { displayMobile } = this.state;
      const { mobileBreakpoint } = this;

      if (window.innerWidth < mobileBreakpoint && !displayMobile) {
        this.setState({
          displayMobile: true,
        });
      }
      if (window.innerWidth >= mobileBreakpoint && displayMobile) {
        this.setState({
          displayMobile: false,
        });
      }

      this.setDoorSize();
    }, 100);
  };

  setImageRef = (element) => {
    this.image = element;
    this.image.addEventListener('load', this.setDoorSize);
  };

  setContainerRef = (element) => {
    this.container = element;
  };

  getBackgroundImageDimensions = () => {
    const { image } = this;

    return {
      data_natural_width: image.naturalWidth,
      data_width: image.clientWidth,
    };
  };

  initializeState = (initialData) => {
    const {
      ID,
      adventcount_background,
      adventcount_background_preselected,
      adventcount_background_img_url,
      adventcount_background_mobile_img_url,
      adventcount_diff_bg,
      adventcount_door_type,
      adventcount_door_shape_url,
      adventcount_door_img_url,
      adventcount_background_color,
      adventcount_border_color,
      adventcount_share_content,
      adventcount_multi_participation_notification,
      adventcount_notif_type_multi,
      adventcount_mp_content,
      adventcount_mp_content_link,
      adventcount_participation_successful,
      adventcount_notif_type,
      adventcount_ps_content,
      adventcount_ps_content_link,
      adventcount_form,
      adventcount_entry_url,
      adventcount_data_query,
      doors,
      adventcount_door_size,
      adventcount_footer_text,
      adventcount_logo_url,
      adventcount_snowflakes,
      adventcount_text_color,
      adventcount_door_shape_base_url,
      adventcount_doors_on,
      adventcount_width,
      adventcount_width_number,
      adventcount_data_query_headline,
      adventcount_email_validation,
      adventcount_field_notification,
      adventcount_door_display,
      adventcount_wrong_door,
      adventcount_wd_content,
      adventcount_calendar_not_started,
      adventcount_cns_content,
      adventcount_cns_content_link,
      adventcount_calendar_finished,
      adventcount_cf_content,
      adventcount_cf_content_link,
      adventcount_start_date,
      adventcount_end_date,
    } = initialData;
    const { mobileBreakpoint } = this;
    const { internalPreview } = this.props;
    const backgroundImage = adventcount_background === 'preselection'
      ? adventcount_background_preselected
      : adventcount_background_img_url;

    const {
      AdventCount: {
        translations: {
          common: {
            fieldRequired,
            emailInvalid,
          },
        },
      },
    } = window;

    let formSchema = adventcount_form;
    if (Array.isArray(formSchema)) {
      formSchema = {};
    }

    this.state = {
      id: ID,
      snowflake: adventcount_snowflakes === 'on',
      dialogShown: false,
      companyLogo: adventcount_logo_url,
      footerHtml: adventcount_footer_text,
      shareContent: adventcount_share_content || '',
      differentBackgroundMobile: adventcount_diff_bg === 'on',
      backgroundImage,
      mobileBackgroundImage: adventcount_diff_bg === 'on' ? adventcount_background_mobile_img_url : backgroundImage,
      borderColor: adventcount_border_color || '#000',
      backgroundColor: adventcount_background_color || '#fff',
      textColor: adventcount_text_color || '#000',
      doorImage: adventcount_door_type === 'preselection' ? adventcount_door_shape_url : adventcount_door_img_url,
      doorImageType: adventcount_door_type,
      doorSize: adventcount_door_size,
      doorShapeBaseUrl: adventcount_door_shape_base_url,
      doorsDisplayed: adventcount_doors_on === 'on',
      doors,
      collectUserData: adventcount_data_query === 'on',
      formSchema,
      entryUrl: adventcount_entry_url,
      successDisplayed: adventcount_participation_successful === 'on',
      successType: adventcount_notif_type,
      successMsg: adventcount_notif_type === 'individual'
        ? adventcount_ps_content
        : adventcount_ps_content_link,
      existingEntryDisplayed: adventcount_multi_participation_notification === 'on',
      existingEntryType: adventcount_notif_type_multi,
      existingEntryMsg: adventcount_notif_type_multi === 'individual'
        ? adventcount_mp_content
        : adventcount_mp_content_link,
      maxWidth: adventcount_width === 'auto' ? '100% !important' : `${parseInt(adventcount_width_number, 10)}px !important`,
      displayMobile: (window.innerWidth < mobileBreakpoint),
      displayMobileType: adventcount_door_display,
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight,
      wrongDoor: adventcount_wrong_door,
      wrongDoorContent: adventcount_wd_content,
      calendarNotStartedMsg: adventcount_calendar_not_started === 'individual'
          ? adventcount_cns_content
          : adventcount_cns_content_link,
      calendarFinishedMsg: adventcount_calendar_finished === 'individual'
          ? adventcount_cf_content
          : adventcount_cf_content_link,
      calendarStartDate: adventcount_start_date,
      calendarEndDate: adventcount_end_date,
      dataQueryHeadline: adventcount_data_query_headline,
    };

    this.emptyFieldValidation = adventcount_field_notification || fieldRequired;
    this.emailValidation = adventcount_email_validation || emailInvalid;
  };

  registerGlobalUpdateMethods = () => {
    const {
      id,
    } = this.state;

    if (!window.AdventCalendar) {
      window.AdventCalendar = {};
    }
    window.AdventCalendar[id] = {};
    window.AdventCalendar[id].setSnowflake = (state) => {
      this.setState({
        snowflake: state === 'on',
      });
    };
    window.AdventCalendar[id].setBackgroundImage = (image) => {
      this.setState({
        backgroundImage: image,
      });
    };
    window.AdventCalendar[id].setCustomDoorBackgroundImage = (image) => {
      this.setState({
        doorImageType: 'custom',
        doorImage: image,
      });
    };
    window.AdventCalendar[id].setPreselectedDoorBackgroundImage = (shape, border) => {
      const { doorShapeBaseUrl } = this.state;
      this.setState({
        doorImageType: 'preselection',
        doorImage: `${doorShapeBaseUrl}shape-${shape}-${border}.svg`,
      });
    };
    window.AdventCalendar[id].setDoorSize = (size) => {
      this.setState({
        doorSize: size,
      });
    };
    window.AdventCalendar[id].setDoorBackgroundColor = (color) => {
      this.setState({
        backgroundColor: color,
      });
    };
    window.AdventCalendar[id].setDoorBorderColor = (color) => {
      this.setState({
        borderColor: color,
      });
    };
    window.AdventCalendar[id].setDoors = (doors) => {
      doors.map((door, index) => ({
        ...door,
        number: index + 1,
      }));

      this.setState({
        doors,
      });
    };
    window.AdventCalendar[id].updateDoorPosition = (doorIndex, top, left) => {
      const { doors } = this.state;
      const newDoors = doors;
      newDoors[doorIndex] = {
        ...doors[doorIndex],
        top,
        left,
      };

      this.setState({
        doors: newDoors,
      });
    };
    window.AdventCalendar[id].updateDoorResizePosition = (doorIndex, top, left, size) => {
    	const { doors } = this.state;
    	const newDoors = doors;
    	newDoors[doorIndex] = {
    		...doors[doorIndex],
			top,
			left,
			size,
		};

    	this.setState({
			doors: newDoors,
		});
    };
    window.AdventCalendar[id].getDoorInfo = (doorIndex) => {
      const { doors } = this.state;

      return doors[doorIndex];
    };
  };

  doorClickHandler = (event) => {
    const { internalPreview, backendPreview } = this.props;
    const { doors, wrongDoor } = this.state;
    const { currentTarget } = event;
    const doorIndex = parseInt(currentTarget.getAttribute('data-number'), 10) - 1;
    const doorStartTimestamp = doors[doorIndex].calendardoor_duration_start_date;
    const doorEndTimestamp = doors[doorIndex].calendardoor_duration_end_date;
    let current_time = Math.round(Date.now() / 1000);
    const now = current_time;

    // show doors if:
    // preview is false and wrongdoor is on
    // preview is false and start and end date match todays date
    // preview is on

    let doorNotReady = false;

    if (
      now < parseInt(doorStartTimestamp, 10)
      || now > parseInt(doorEndTimestamp, 10)
    ) {
      doorNotReady = true;
    }

    if ( backendPreview != "1" ) {
    if ( internalPreview || ( !internalPreview && wrongDoor == 'on' ) || ( !internalPreview && !doorNotReady ) ) {
      const doorElements = Array.from(document.querySelectorAll('.adventcalendar__door'));
      const doorEl = currentTarget.parentElement.parentElement;
      const doorOpenAnimationEnd = () => {
        doorEl.removeEventListener('transitionend', doorOpenAnimationEnd);
        this.setState({
          dialogShown: currentTarget.getAttribute('data-number'),
        });
      };

      doorElements.forEach((door) => {
        door.setAttribute('hidden', '');
      });
      doorEl.removeAttribute('hidden');
      doorEl.classList.add('animated');
      doorEl.addEventListener('transitionend', doorOpenAnimationEnd);
    }
    }
  };

  doorCloseClickHandler = () => {
    const openedDoor = document.querySelector('.adventcalendar__door.animated');
    const link = openedDoor.querySelector('a');
    const videos = document.querySelector(link.getAttribute('href')).querySelectorAll("video");
    if (videos.length) {
      for (let i = 0; i < videos.length; i += 1) {
        videos[i].pause();
      }
    }

    const doorCloseAnimationEnd = () => {
      openedDoor.removeEventListener('transitionend', doorCloseAnimationEnd);
      const doors = document.querySelectorAll('.adventcalendar__door');
      doors.forEach((door) => {
        door.removeAttribute('hidden');
      });
    };
    openedDoor.addEventListener('transitionend', doorCloseAnimationEnd);
    openedDoor.classList.remove('animated');

    this.setState({
      dialogShown: 0,
    });
  };

  finishedDialogClose = () => {
    this.FinishedDialogShown = false;

    this.setState({
      dialogShown: false,
    });
  };

  renderDialog = () => {
    const {
      id,
      dialogShown,
      collectUserData,
      formSchema,
      entryUrl,
      successDisplayed,
      successType,
      successMsg,
      existingEntryDisplayed,
      existingEntryType,
      existingEntryMsg,
      data,
      calendarStartDate,
      calendarEndDate,
      calendarFinishedMsg,
      calendarNotStartedMsg,
    } = this.state;
    const { internalPreview } = this.props;

    if ( !internalPreview && this.now <= parseInt( calendarStartDate ) ) {
      const doorElements = Array.from(document.querySelectorAll('.adventcalendar__door'));
      doorElements.forEach((door) => {
        door.setAttribute('hidden', '');
      });
      return (
          <>
            { !internalPreview &&
            <CalendarFinishedPopupContainer
                dialogShown={this.FinishedDialogShown}
                content={calendarNotStartedMsg}
                doorCloseClickAction={this.finishedDialogClose}
            />}
          </>
      );
    } else if ( !internalPreview && this.now >= parseInt(calendarEndDate)) {
      const doorElements = Array.from(document.querySelectorAll('.adventcalendar__door'));
      doorElements.forEach((door) => {
        door.setAttribute('hidden', '');
      });
      return (
          <>
            { !internalPreview &&
            <CalendarFinishedPopupContainer
                dialogShown={this.FinishedDialogShown}
                content={calendarFinishedMsg}
                doorCloseClickAction={this.finishedDialogClose}
            />}
          </>
      );
    }
  };

  render() {
    const {
      dialogShown,
      companyLogo,
      footerHtml,
      shareContent,
      backgroundImage,
      mobileBackgroundImage,
      displayMobile,
      backgroundColor,
      borderColor,
      doorImage,
      textColor,
      doorSize,
      doorImageType,
      doorsDisplayed,
      doors,
      collectUserData,
      formSchema,
      entryUrl,
      successDisplayed,
      successType,
      successMsg,
      existingEntryDisplayed,
      existingEntryType,
      existingEntryMsg,
      snowflake,
      maxWidth,
      displayMobileType,
      wrongDoor,
      wrongDoorContent,
      dataQueryHeadline,
    } = this.state;
    const { internalPreview, backendPreview } = this.props;

    const background = displayMobile ? mobileBackgroundImage : backgroundImage;
    let doorDisplayedMobile = false;
    return (
      <AdventCalendarContainer
        className="adventcalendar"
        textColor={textColor}
        maxWidth={maxWidth}
        ref={this.setContainerRef}
      >
        <div className="adventcalendar_doors_container_wrapper" ref={this.setContainerRef}>
          <img src={background} alt="calendar-background" ref={this.setImageRef} />
          <div className="adventcalendar__doors-wrapper">
            {snowflake && (
              <DepthOfFieldSnowfall
                count={20}
                style={{
                  position: 'absolute',
                  width: '95%',
                  height: '95%',
                  top: '5%',
                  left: '5%',
                  transform: 'translate(-2.5%, -2.5%)',
                  color: 'white',
                }}
              />
            )}
            {doorsDisplayed && doors.map((door, index) => {
              const {
                calendardoor_duration_start_date,
                calendardoor_duration_end_date,
                calendardoor_show_answer,
              } = door;

              if (
                !displayMobile
                || !doorDisplayedMobile
                || (
                  this.now >= parseInt(calendardoor_duration_start_date)
                  && this.now <= parseInt(calendardoor_duration_end_date)
                )
              ) {
                let { top, left } = door;

                // If a single door display is set on mobile view then
                // display the first one that falls within current date range only
                if (displayMobileType !== 'all' && displayMobile) {
                  if ( this.now >= parseInt(calendardoor_duration_start_date) && this.now <= parseInt(calendardoor_duration_end_date)) {
                    doorDisplayedMobile = true;
                    top = 49.9;
                    left = 49.9;
                  }
                  else {
                    doorDisplayedMobile = false;
                    top = 49.9;
                    left = 49.9;
                    // return '';
                  }
                }


                let localDoorSize = doorSize;

                if (typeof (door.size) !== 'undefined') {
                	if (door.size !== 0) {
                	  localDoorSize = this.calcuateSize(door.size);
                	}
                }

                let show_answer = false;
                if ( calendardoor_show_answer == 'on' ) {
                  show_answer = true;
                }

                return (
                  <Door
                    key={door.number}
                    top={top}
                    left={left}
                    data={door}
                    number={index + 1}
                    isMobile={displayMobile}
                    backgroundImg={doorImage}
                    backgroundColor={backgroundColor}
                    borderColor={borderColor}
                    textColor={textColor}
                    imageType={doorImageType}
                    dialogShown={parseInt(dialogShown, 10) === parseInt(door.number, 10)}
                    doorClickAction={this.doorClickHandler}
                    doorCloseClickAction={this.doorCloseClickHandler}
                    doorSize={parseInt(localDoorSize, 10)}
                    internalPreview={internalPreview}
                    backendPreview={backendPreview}
                    hasQuiz={door.calendardoor_question !== 'on'}
                    showAnswer={show_answer}
                    collectUserData={collectUserData}
                    formSchema={formSchema}
                    entryUrl={entryUrl}
                    successDisplayed={successDisplayed}
                    successType={successType}
                    successMsg={successMsg}
                    existingEntryDisplayed={existingEntryDisplayed}
                    existingEntryType={existingEntryType}
                    existingEntryMsg={existingEntryMsg}
                    emptyFieldMsg={this.emptyFieldValidation}
                    emailFieldMsg={this.emailValidation}
                    wrongDoor={wrongDoor}
                    wrongDoorContent={wrongDoorContent}
                    dataQueryHeadline={dataQueryHeadline}
                  />
                );
              }
              return '';
            })}
            {this.renderDialog()}
          </div>
        </div>
        {(companyLogo || footerHtml || shareContent) && (
          <Footer
            shareContent={shareContent}
            companyLogoImg={companyLogo}
            text={footerHtml}
          />
        )}
      </AdventCalendarContainer>
    );
  }
}

AdventCalendar.propTypes = {
  internalPreview: PropTypes.bool,
  backendPreview: PropTypes.bool,
  calendarId: PropTypes.string.isRequired,
};

AdventCalendar.defaultProps = {
  internalPreview: false,
  backendPreview: false
};
